import { getUserOddsChangeRules } from 'features/coupon/utility';
import { AKO, vipLevelArray, vipStakes } from 'shared/constants/common';
import { FINANCIAL_THRESHOLDS } from 'shared/constants/financial-thresholds';
import { Action, BETSType, CouponState } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { getBetsDetail, getUserDetails, setBetsDetail } from 'shared/util/utility';

let bets: BETSType = getBetsDetail();

const userOddsChangeRules = getUserOddsChangeRules();
const vipStatusData = getUserDetails()?.vipStatusData;

const calculateStake = (vipStatusData: any): number => {
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return vipStatusData !== undefined && typeof vipStakes[vipLevelArray[vipStatusData]!]! === 'number'
		? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		  vipStakes[vipLevelArray[vipStatusData]!]!
		: FINANCIAL_THRESHOLDS.DEFAULT_STAKE;
};

export const DefaultBetslipState = {
	stake: calculateStake(vipStatusData),
	betType: 0,
	outcomes: [],
	currencyCode: 'PLN',
	bonusBet: false,
	betMode: AKO,
	blocks: [],
	freeBetStack: null,
	isFreeBetSelected: false,
	...userOddsChangeRules,
};

const storageFlag = Object.getOwnPropertyNames(bets).length === 0;
if (storageFlag) {
	setBetsDetail(DefaultBetslipState);
} else {
	bets = {
		...bets,
		...userOddsChangeRules,
		stake: calculateStake(vipStatusData),
	};
	setBetsDetail(bets);
}

const initialState: CouponState = {
	bets: storageFlag ? DefaultBetslipState : { ...bets, ...userOddsChangeRules },
	betStatics: {},
	awaitingWinningResp: false,
	analytics: {
		removedBets: 1,
		replacedBets: 1,
		enabledBets: 1,
		disabledBets: 1,
	},
};

const getFilteredBets = (bets: BETSType) => {
	bets.outcomes.filter((item) => item.eventId > 0);
	return {
		...bets,
		outcomes: bets.outcomes.filter((item) => item.eventId > 0),
	};
};

export const CouponReducer = (state: CouponState = initialState, action: Action): CouponState => {
	switch (action.type) {
		case actionTypes.ADD_BET:
			return {
				...state,
				bets: getFilteredBets(action.payload.bets),
			};
		case actionTypes.REMOVE_FREE_BET_STACK:
			const bets = state.bets;
			bets.freeBetStack = null;
			bets.isFreeBetSelected = false;
			return {
				...state,
				bets,
			};
		case actionTypes.CALCULATE_TAX_SUCCESS:
			return {
				...state,
				betStatics: action.payload.betStatics,
				awaitingWinningResp: action.payload.skipCancelLoading || false,
			};
		case actionTypes.CALCULATE_TAX_INIT:
			return {
				...state,
				awaitingWinningResp: action.payload.awaitingWinningResp,
			};
		case actionTypes.CHANGE_BET_OUTCOMES_SUCCESS:
			return {
				...state,
				bets: getFilteredBets(action.payload.bets),
			};
		case actionTypes.CHANGE_BET_MODE:
			return {
				...state,
				bets: { ...state.bets, betMode: action.payload.betMode },
			};
		case actionTypes.ANALYTICS_REMOVE_BET:
			if (state.bets.outcomes.length === 0) {
				return {
					...state,
					bets: {
						...state.bets,
						stake: calculateStake(getUserDetails()?.vipStatusData),
					},
					analytics: {
						...state.analytics,
						removedBets: state.analytics.removedBets + 1,
					},
				};
			}
			return {
				...state,
				analytics: {
					...state.analytics,
					removedBets: state.analytics.removedBets + 1,
				},
			};
		case actionTypes.ANALYTICS_REPLACE_BET:
			return {
				...state,
				analytics: {
					...state.analytics,
					replacedBets: state.analytics.replacedBets + 1,
				},
			};
		case actionTypes.ANALYTICS_ENABLE_BET:
			return {
				...state,
				analytics: {
					...state.analytics,
					enabledBets: state.analytics.enabledBets + 1,
				},
			};
		case actionTypes.ANALYTICS_DISABLE_BET:
			return {
				...state,
				analytics: {
					...state.analytics,
					disabledBets: state.analytics.disabledBets + 1,
				},
			};
		case actionTypes.ANALYTICS_CLEAR_BETS:
			return {
				...state,
				analytics: initialState.analytics,
			};
		case actionTypes.UPDATE_USER_DETAILS:
			const newUserDetails = action.payload;
			return {
				...state,
				bets: {
					...state.bets,
					stake: calculateStake(newUserDetails?.vipStatusData),
				},
			};
		case actionTypes.UPDATE_BETS_STAKE:
			return {
				...state,
				bets: { ...state.bets, stake: action.payload.betsStake },
			};
		default:
			return state;
	}
};
